<router-outlet></router-outlet>
<!-- <ngx-spinner bdColor = "white" size = "medium" color = "rgb(97, 190, 21)" type = "ball-scale-multiple" [fullScreen] = "false"><p style="color: rgb(97, 190, 21)" > Processing... </p></ngx-spinner> -->
<ngx-spinner type="ball-scale-multiple" color = "rgb(97, 190, 21)"></ngx-spinner>